import React from 'react';
import { Box } from '@mui/material';
import logo from '../../images/MEWIN_new_logo.svg';

const GameAreaLoader = ({ showLoader, children }) => {
  const [done, setDone] = React.useState(false);


  React.useEffect(() => {
    if (showLoader) setDone(false);
  }, [showLoader]);

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Box
        sx={{
          filter: (showLoader && !done) ? 'blur(4px)' : 'none',
          pointerEvents: (showLoader && !done) ? 'none' : 'auto',
          transition: 'filter 0.3s ease',
        }}
      >
        {children}
      </Box>

      {showLoader && !done && (
        <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          background: 'rgb(0,0,0)', zIndex: 5 }}>
          
          <Box component="img" src={logo} alt="loading"
            sx={{ width: { xs: '90px', sm: '120px', md: '150px' } }} />

          <Box sx={{ width: { xs: '140px', sm: '180px' }, height: '4px',
            borderRadius: '4px', background: 'rgb(49,49,49)', overflow: 'hidden', mt: 2 }}>
            
            <Box
              onAnimationEnd={() => setDone(true)}  
              sx={{ height: '100%', borderRadius: '4px', background: '#ffffff',
                animation: 'roundLoaderProgress 2s linear forwards' }}
            />
          </Box>
        </Box>
      )}

      <style>{`
        @keyframes roundLoaderProgress {
          0%   { width: 0%; }
          100% { width: 100%; }
        }
      `}</style>
    </Box>
  );
};

export default GameAreaLoader;